T.Download = Class(
	/**
	 * @lends {T.Download#}
	 */
	{
		__construct(className, type){
			let iosURL = 'https://apps.apple.com/us/app/roadgames-app/id1456577716';
			let androidURL = 'https://play.google.com/store/apps/details?id=com.roadgames&hl=' + D.LANG;

			if (type === 'home') {
				iosURL = 'https://apps.apple.com/us/app/roadgames-home/id1540565890';
				androidURL = 'https://play.google.com/store/apps/details?id=com.roadgames.virtual&hl=' + D.LANG;
			}

			this.node = mkE({
				tag: 'div',
				className: 'download',
				els: [
					{
						tag: 'a',
						href: iosURL,
						target: '_blank',
						className: 'store-button ios',
						attr: {
							rel: 'noopener'
						},
						onclick: () => {
							this.sendEvent('appstore');
						}
					},
					{
						tag: 'a',
						href: androidURL,
						target: '_blank',
						className: 'store-button android',
						attr: {
							rel: 'noopener'
						},
						onclick: () => {
							this.sendEvent('play-store');
						}
					}
				]
			});

			if( className ){
				addClassName(this.node, className);
			}
		},

		sendEvent(type) {
			D.gtag('download', {
				ecommerce: {
					type: type
				}
			});
		}
	},
	mkE.Base
);
